/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React, { useContext, useState, useCallback } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Collapsible from '@prisjakt/ui-collapsible';
import { ScrollElement } from '@prisjakt/ui-scroll';

import Banner from '../banner';
import PeakIndex from '../peak-index';
import AdContainer from '../../../../components/ads';
import { useViewportContext } from '../../../../components/viewport/context';

import * as S from './styles';

const CampaignHeader = props => {
  const { renderMode, t } = useContext(AppContext);
  const { isMobile, isTablet } = useViewportContext();
  const shouldCollapseDescription = isMobile || isTablet;
  const [descriptionCollapsed, setDescriptionCollapsed] = useState(
    shouldCollapseDescription
  );
  const expandDescription = useCallback(
    () => setDescriptionCollapsed(false),
    []
  );
  const isCollapsed = shouldCollapseDescription && descriptionCollapsed;

  return props.campaign ? (
    <S.Header>
      <S.Container>
        <S.LogoAndText>
          <S.Logo>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href=""
              onClick={event => {
                event.preventDefault();
                props.onClear();
              }}
            >
              <Banner
                banners={props.campaign.banners}
                type="banner_logo_big"
                alt={props.campaign.title.page}
              />
            </a>
          </S.Logo>
          <S.Content>
            <S.Title>{props.campaign.facetted.title}</S.Title>
            <Collapsible
              collapsed={isCollapsed}
              expandText={t('symbols', 'symbol.expand')}
              onExpand={expandDescription}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: props.campaign.facetted.description,
                }}
              />
            </Collapsible>
          </S.Content>
        </S.LogoAndText>
        {renderMode !== 'desktop' && props.campaign.peakIndex && !isCollapsed && (
          <S.PeakIndex>
            <PeakIndex {...props.campaign.peakIndex} />
          </S.PeakIndex>
        )}
        {renderMode === 'desktop' && (
          <AdContainer placement="small_insider_1" min={640} max={10000} />
        )}
      </S.Container>
      <S.Ads>
        <ScrollElement name="CampaignHeaderAd">
          <AdContainer placement="dubbelpanorama1" min={0} max={639} />
        </ScrollElement>
      </S.Ads>
    </S.Header>
  ) : null;
};

const { shape, string, number, bool, arrayOf, func } = PropTypes;

CampaignHeader.propTypes = {
  campaign: shape({
    id: number.isRequired,
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
    descriptionHtml: shape({
      long: string,
    }),
    banners: arrayOf(
      shape({
        type: string,
        url: string,
        imageUrl: string,
      })
    ),
  }).isRequired,
  isActive: bool.isRequired,
  onClear: func.isRequired,
};

export default CampaignHeader;
